import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

export function MeetingReportHeader() {
    return (
        <Stack spacing={2}>
            <Body size='xlarge' color='dark' isBold={true}>
                Scheduler meeting report
            </Body>
            <Body size='normal' color='medium'>
                Booking stats and trends for your meeting in the past 3 months
            </Body>
        </Stack>
    );
}
